import { fabric } from 'fabric';

/**
 * ImageAsync object class
 *
 */
const ImageAsync = fabric.util.createClass(fabric.Image, {
  type: 'imageAsync',

  /**
   * Class constructor
   *
   * @param image
   * @param options
   */
  originX: 'center',
  originY: 'center',
  left: 0,
  top: 0,

  initialize: function(src, options, params, initializer) {
    if (
      options &&
      (options.width === undefined || options.height === undefined)
    ) {
      options = {
        ...options,
      };
      this.options = options;
    }
    this.filters = [];
    this.options = options;
    this.rendered = false;
    this.ready = true;
    if (initializer && !params) {
      // used by ludusLottie
      initializer(options, this.initImageRender.bind(this));
    } else if (params && initializer) {
      // used by ludusImage (params and options have different properties for dynamic cropping)
      initializer(params, this.initImageRender.bind(this));
    } else {
      if (typeof src === 'string') {
        this.defaultInitializer(src, this.initImageRender.bind(this));
      } else {
        this.initImageRender(src);
      }
    }
    if (options && !this.loaded) {
      this.setOptions({
        ...options,
      });
    }
  },

  defaultInitializer(src) {
    fabric.util.loadImage(
      src,
      image => {
        this.initImageRender(image);
      },
      null,
      'Anonymous',
    );
  },

  prepareCanvasRendering() {
    if (this.group) {
      this.group.hasControls = true;
      this.group.dirty = true;
    }

    this._initElement(this.image, this.options);
    this.setCoords();
    this.rendered = true;
    this.group?.setImageCoords && this.group.setImageCoords();

    if (this.canvas && this.canvas.allImagesRendered()) {
      this.canvas.requestRenderAll();
      this.canvas.fire('object:allImagesRendered');
    }
  },

  initImageRender(image, error) {
    this.image = image;
    if (image) {
      this.localImage = image.src.startsWith('blob:http');

      this.loaded = true;
      // image used by ludusImage
      if (this.group && image && image.width && image.height) {
        // not group width or height means we just added the image
        // let's center it

        if (!this.group.width || !this.group.height) {
          this.group.set({
            width: this.image.width,
            left: this.group.left - this.image.width / 2,
            height: this.image.height,
            top: this.group.top - this.image.height / 2,
          });
          this.canvas &&
            this.canvas.fire('object:modified', {
              target: this.group,
            });
        }

        if (
          !this.group._originalHeight ||
          !this.group._originalWidth ||
          this.group._originalWidth !== this.image.width ||
          this.group._originalHeight !== this.image.height
        ) {
          this.group._originalWidth = this.image.width;
          this.group._limitedWidth = this.image.width;
          this.group._limitedHeight = this.image.height;
          this.group.ludus.originalWidth = this.image.width;
          this.group._originalHeight = this.image.height;
          this.group.ludus.originalHeight = this.image.height;
        }
        this.group.setCoords();
      }

      // image used by something else than ludusImage
      if (!this.group && image && image.width && image.height) {
        this.height = image.height;
        this.width = image.width;
        this.left = 0;
        this.top = 0;
      }

      if (this.canvas) {
        this.prepareCanvasRendering();
        // make sure to re-apply the width and height, because when loaded from a symbol
        // the imageScaleX and Y is reset to 1/1
        this.group &&
          this.group.set({
            width: this.group.width,
            height: this.group.height,
          });
      } else {
        // if the canvas is not available most likely a sync operation blocking it at this frame,
        // like another not-async image using the canvas while loading/rendering
        this.delayPrepareCanvasRendering();
      }
    } else {
      if (this.group) this.group.dirty = true;
      this.loaded = false;
      this.rendered = false;
      if (this.canvas) {
        this.canvas.requestRenderAll();
        this.prepareCanvasRendering();
      } else {
        this.delayPrepareCanvasRendering(50);
      }
    }
  },

  delayPrepareCanvasRendering: function(delay) {
    setTimeout(() => {
      if (this.canvas) {
        this.prepareCanvasRendering();
      } else if (delay < 60000) {
        this.delayPrepareCanvasRendering(delay * 2);
      } else {
        console.info('Could never prepare canvas rendering');
      }
    }, delay);
  },

  isFailedLocalImage: function() {
    if (!this.localImage) return false;
    if (this.failed) return true;
    const isFailed =
      window.failedImages && window.failedImages.includes(this.image.src);
    if (isFailed) {
      this.failed = true;
    }
    return isFailed;
  },

  render: function(ctx) {
    if (this.loaded && this.canvas && !this.isFailedLocalImage()) {
      this.callSuper('render', ctx);
    } else {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.15)';
      const width = this.group.width || this.width;
      const height = this.group.height || this.height;
      ctx.fillRect(-(width / 2), -(height / 2), width, height);
    }
  },

  /**
   * Override Applies filters assigned to this image (from "filters" array) or from filter param
   * @method applyFilters
   * @param {Array} filters to be applied
   * @param {Boolean} forResizing specify if the filter operation is a resize operation
   * @return {thisArg} return the fabric.Image object
   * @chainable
   */
  applyFilters: function(filters) {
    if (this.loaded && this.canvas && this.image) {
      this.callSuper('applyFilters', filters);
    } else {
      return this;
    }
  },
});

export default ImageAsync;
